export const paragraph = [
    {
      id: 1,
      text: "HStimulate your mind as you test your typing speed with this standard English paragraph typing test. Watch your typing speed and accuracy increase as you learn about a variety of new topics! Over 40 typing test selections available.",
    },
    {
      id: 2,
      text: "If you don't like a test prompt, you can get a different (random) prompt with the change test button - or select a specific paragraph to type from the list below. To find out how fast you type, just start typing in the blank textbox on the right of the test prompt. You will see your progress, including errors on the left side as you type. In order to complete the test and save your score, you need to get 100% accuracy. You can fix errors as you go, or correct them at the end with the help of the spell checker.",
    },
    {
      id: 3,
      text: "This feedback graph will follow you from page to page for your typing session. You can see more details by mousing over the graph. The session is reset when the tab on your browser is closed.",
    },
    {
      id: 4,
      text: "Medical transcription, also known as MT, is an allied health profession dealing with the process of transcribing voice-recorded medical reports that are dictated by physicians, nurses and other healthcare practitioners. Medical reports can be voice files, notes taken during a lecture, or other spoken material. These are dictated over the phone or uploaded digitally via the Internet or through smart phone apps.",
    },
  ];
  